import React from 'react';
import Lottie from 'lottie-react';

import Container from 'components/Container';

import dashboardAnimation from 'assets/animations/data_dashboard.json';

import {
  Section,
  GrafanaContainer,
  LeftContent,
  RightContent,
  MainTitle,
  MainDescription,
  FeatureList,
  FeatureItem,
  AnimationWrapper,
} from './AIAssistant.styles';

const AIAssistant = () => {
  return (
    <Section>
      <Container>
        <MainTitle>Benefits of AI Automation</MainTitle>
        <GrafanaContainer>
          <LeftContent>
            <MainDescription>
              Unlock the power of AI automation to transform your business
              operations. From intelligent chatbots that handle customer
              inquiries 24/7 to data dashboards that reveal actionable insights,
              we help you make smarter decisions faster.
            </MainDescription>
            <FeatureList>
              <FeatureItem>
                Smart Chatbots that automate customer support and reduce
                response time by 80%
              </FeatureItem>
              <FeatureItem>
                Data Insight Dashboards that transform complex data into clear,
                actionable visualizations
              </FeatureItem>
              <FeatureItem>
                Big Data Analytics that uncover hidden patterns and predict
                business trends
              </FeatureItem>
              <FeatureItem>
                Automated Workflows that eliminate repetitive tasks and boost
                team productivity
              </FeatureItem>
            </FeatureList>
          </LeftContent>
          <RightContent>
            <AnimationWrapper>
              <Lottie animationData={dashboardAnimation} loop autoplay />
            </AnimationWrapper>
          </RightContent>
        </GrafanaContainer>
      </Container>
    </Section>
  );
};

export default AIAssistant;
